<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 col-xs-12 plr-7" style="background-color: #f7f7f7">
        <h1
          class="mt-2 mb-4 center color-primary"
          style="font-family: Comfortaa-Bold"
        >
          Jovool
        </h1>
        <!-- <transation enter-active-class="bounceLeft-enter" leave-active-class="bounceRight-leave"> -->
        <transition name="fadeLeft" mode="out-in" appear>
          <SignUp v-if="stepOne" @setEmail="setEmail" />
          <div v-if="stepTwo">
            <h1>CADASTRO REALIZADO COM SUCESSO</h1>
            <p>
              ENVIAMOS UM
              <strong>E-MAIL</strong>PARA A CONFIRMAÇÃO DE CONTA, ENTRE EM SUA
              CAIXA DE EMAIL E ATIVE SUA CONTA, CASO NÃO ENCONTRE VERIFIQUE SUA
              CAIXA DE SPAN OU
              <a href="recruiters/confirmation/new">CLIQUE AQUI</a> PARA PEDIR
              UM NOVO E-MAIL DE CONFIRMAÇÃO
            </p>

            <p>
              NÃO RECEBEU EMAIL DE CONFIRMAÇÃO?
              <inertia-link href="/recruiters/confirmation/new"
                >CLIQUE AQUI PARA ENVIAR</inertia-link
              >
            </p>
          </div>
        </transition>
        <!-- </transation> -->
      </div>
      <transition name="fade">
        <div
          v-if="show"
          class="col-lg-6 center col-xs-12 p-7 loginPanel"
          style="min-height: 100vh"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import SignUp from "pages/Recruiters/Registrations/SignUp.vue";
import CompleteRegister from "pages/Recruiters/Registrations/CompleteRegister.vue";

export default {
  components: { SignUp, CompleteRegister },
  data: () => ({
    show: false,
    stepOne: false,
    stepTwo: false,
    email: "",
  }),
  created() {
    eventBus.$on("stepTwo", (status) => {
      this.stepOne = false;
      this.stepTwo = true;
    });
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      this.show = true;
      this.stepOne = true;
    }, 500);
  },
  methods: {
    setEmail(email) {
      this.email = email;
    },
  },
};
</script>

